<template>
    <div class="form-group">
        <div class="col-xs-12">
            {{ 'Fix new appointment with this client' | trans }}
        </div>
        <div class="col-xs-9">
            <textarea
                    v-model="comment"
                    v-bind:placeholder="'Write here any useful info (reason, timing, etc.)' | trans"
                    type="text"
                    cols="24"
                    name=""
                    class="form-control">
            </textarea>
        </div>
        <div class="col-xs-3">
            <button
                    v-on:click="$emit('comment:validate', comment)"
                    class="small-btn-close-input btn-primary">
                {{ 'OK' | trans }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                comment: ''
            };
        }
    }
</script>
